import { useMemo } from "react";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type SpaceData = {
  id: string;
  name: string;
  parentSpace: string | null;
  inheritEntities: boolean;
};

type SpaceSelectorDebuggerProps = {
  spaces: SpaceData[];
  selectedSpacesIds: Set<string>;
};

const SpaceSelectorDebugger = ({ spaces, selectedSpacesIds }: SpaceSelectorDebuggerProps) => {
  const selectedSpaceNames = useMemo(() => {
    return Array.from(selectedSpacesIds)
      .map((id) => spaces.find((s) => s.id === id)?.name || id)
      .sort();
  }, [selectedSpacesIds, spaces]);

  return (
    <Box direction="column" gap="small" className={styles.debugPanel}>
      <Typography variant="p-t7" tag="div">
        Currently Selected ({selectedSpacesIds.size}):
      </Typography>
      <Box direction="column" gap="small" className={styles.debugList}>
        {selectedSpaceNames.map((name, index) => (
          <Typography
            key={`${name}-${index}`}
            variant="p-body3"
            tag="div"
            className={styles.debugItem}
          >
            • {name}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default SpaceSelectorDebugger;
